import React, {useEffect, useState} from "react";
import {Col, OverlayTrigger, Row, Tooltip} from "react-bootstrap";
import {faEdit, faPlusSquare, faTrash} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import InlineEditable from "../../../Scheduler/InlineEditable";
import {CrewMessageEditor} from "../../../Scheduler/CrewMessages/CrewMessagesEditor";
import TimelineElementWrapper from "./TimelineElementWrapper"
import {hexToRGB} from "../../../../common/commonHandlers";

const TimelineNote = ({note, color, employeeName, currentUserPersonId, employeeDisabled, onSave, onDelete, readOnly, proposalNo}) => {
    const [showNote, setShowNote] = useState(false)
    const [editNote, setEditNote] = useState(false)
    const [textNote, setTextNote] = useState(null)

    useEffect(() => {
        if (note && textNote && note.notes !== textNote) {
            note.notes = textNote
            onSave(note)
        }
        if (!note?.id && textNote && textNote !== " " && textNote !== '<p></p>\n') {
            onSave({notes: textNote})
        }

    }, [editNote])

    const editArea = (note) => {
        return (
            <InlineEditable
                editMessage={editNote}
                editable={editNote}
                closeEditable={() => setEditNote(false)}
                form={() =>
                    <CrewMessageEditor
                        autoFocus={true}
                        customClass="editor"
                        setValue={value => setTextNote(value)}
                        messageId={note && note.id}
                        reply={note && note.notes && note.notes}
                    />
                }
            />
        )
    }

    const topIcons = () => {
        return (
            <>
                <FontAwesomeIcon icon={faEdit} onClick={() => {
                    if (!document.getElementById("editor")) {
                        setEditNote(true)
                        setTextNote(note.notes ? note.notes : " ");
                    }
                }} className="mr-3 pointer"/>
                <FontAwesomeIcon icon={faTrash} onClick={() => {
                    onDelete(note.id)
                }} className="pointer"/>
            </>
        )
    }

    const getTextWidth = (text, font) => {
        const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
        const context = canvas.getContext("2d");
        context.font = font;
        const metrics = context.measureText(text);
        return metrics.width;
    }

    const textWidth = (note) => getTextWidth(note, "15px Open Sans")
    const containerWidth = document.getElementById('note')?.clientWidth

    const isMultipleParagraph = () => {
        return note?.notes?.split('<p>').length > 2
    }

    const isShortNote = (note) => {
        return containerWidth > textWidth(note)
    }

    const RGBColor = color && hexToRGB(color)
    const initials = employeeName && employeeName.match(/\b(\w)/g).join('')

    const oneParagraphNote = note?.notes?.replace(/(<[^>]*>|&nbsp;)/g, '')

    return (
        note ?
            <TimelineElementWrapper
                color={color}
                employeeName={employeeName}
                employeeDisabled={employeeDisabled && employeeDisabled}
                createdAt={note && note.created_at}
                topElement={note && !readOnly && currentUserPersonId === note?.person_id && topIcons()}
                bottomElement={note && !readOnly && note.created_at !== note.updated_at && <i>(edited)</i>}
                isShowDetail={showNote}
                hideEvent={() => setShowNote(false)}
            >
                <Row>
                    <Col md={12} xs={12}>
                        <>
                            {editArea(note)}
                            <OverlayTrigger
                                placement="top"
                                overlay={showNote || (!isMultipleParagraph() && isShortNote(oneParagraphNote)) ? <></> :
                                    <Tooltip id="tooltip">Click to show more!</Tooltip>}
                            >
                                <p id="note"
                                   onClick={() => !isMultipleParagraph() && isShortNote(oneParagraphNote) ? {} : setShowNote(true)}
                                   className={`${showNote || (!isMultipleParagraph() && isShortNote(oneParagraphNote)) ? 'message-show' : 'message-hidden'} fontSize15 no-margin-bottom`}>
                                    {proposalNo && <b className="font11">Proposal #{proposalNo}</b>}
                                    {!editNote && <div dangerouslySetInnerHTML={{__html: note.notes}}/>}
                                </p>
                            </OverlayTrigger>
                        </>
                    </Col>
                </Row>
            </TimelineElementWrapper>
            :
            <Col md={12} xs={12} className={`add-new-note-wrapper ${editNote ? "pad5-0" : ""}`}>
                <div className={!editNote ? "add-new-note" : ""}>
                    <div className={`${editNote && "container"}`}>
                        {editNote && RGBColor && <div className='circle vhCenter' style={{
                            borderColor: `${color}`,
                            background: `rgba(${RGBColor.r}, ${RGBColor.g}, ${RGBColor.b}, 0.2)`
                        }}>
                            <OverlayTrigger placement="right"
                                            overlay={<Tooltip
                                                id="tooltip">{employeeName && employeeName}</Tooltip>}>
                                <span>{initials}</span>
                            </OverlayTrigger>
                        </div>}
                        {editArea()}
                    </div>
                    {!editNote &&
                        <p onClick={() => {
                            if (!document.getElementById("editor")) {
                                setEditNote(true)
                                setTextNote(" ")
                            }
                        }}
                           className="pointer d-flex no-margin">
                            <FontAwesomeIcon icon={faPlusSquare} className="bigger mr-3"/>
                            Add New Note
                        </p>}
                </div>
            </Col>
    )
}

export default TimelineNote;